import { useState, useEffect } from 'react'
import { District } from '../models/_models'

const useDistricts = () => {
  const [districts, setDistricts] = useState([])

  useEffect(() => {
    District
      .per(1000)
      .order('name')
      .all()
      .then((res) => setDistricts(res.data))
  }, [])

  return districts
}

export default useDistricts
